import { useApp } from '../context/AppContext'

/**
 * Indica si el usuario actual tiene un permiso (vista) concedido.
 * Versión programática de {@link AuthAccessValidator} para usar en lógica
 * (filtrar datos, condicionar handlers, etc.).
 *
 * @param {string} slug - `vista_slug` del permiso requerido (p. ej. 'ticket_support').
 * @returns {boolean}
 */
export default function useHasAccess(slug) {
  const { access = [] } = useApp()
  return access.some((p) => p?.vista_slug === slug && p?.puede_ver === true)
}
